import { crmSystem } from "@/constants/crm/_shared/systems";
import { ConfigurationParameterInput } from "./ConfigurationParameterInput";
import { FullConfiguration } from "@/types/crm/configuration/configuration";
import { FullParameterData } from "@/types/crm/configuration/parameter";
import { UseFormReturn } from "react-hook-form";
import { selectedConfigurationSchema } from "@/lib/schema/configuration/configuration";
import { z } from "zod";

export const projectParametersFormSchema = z.object({
    selected_configuration: selectedConfigurationSchema.optional().nullable().default(null),
});

export type ProjectParametersFormSchemaType = z.infer<typeof projectParametersFormSchema>;

interface ProjectConfigurationParameterInputProps {
    crmSystem: crmSystem | undefined | null;
    parameters: FullParameterData[];
    form: UseFormReturn<ProjectParametersFormSchemaType>;
    fullConfiguration: FullConfiguration;
}

export function ProjectConfigurationParameterInput({
    crmSystem,
    parameters,
    form,
    fullConfiguration
}: Readonly<ProjectConfigurationParameterInputProps>) {
    const values = parameters.map((_, i) =>
        form.watch(`selected_configuration.parameter.${i}.value`) ?? undefined
    );
    console.log(values)
    const handleChange = (index: number, value: string | null | undefined) => {
        console.log("Changing value at index", index, "to", value);
        form.setValue(`selected_configuration.parameter.${index}.value`, value);
        console.log("Set parameter ID at index", index, "to", parameters[index]?.id);
        form.setValue(`selected_configuration.parameter.${index}.id`, parameters[index]?.id);
    };
    console.log(parameters)
    console.log(fullConfiguration)
    return (
        <ConfigurationParameterInput
            crmSystem={crmSystem}
            parameters={parameters}
            values={values}
            onChange={handleChange}
            fullConfiguration={fullConfiguration}
        />
    );
}
